import { isEmpty, length } from 'ramda';
import React from 'react';
import { shape, array, node, func } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { EmptyTitle } from '../empty';

const messages = defineMessages({
  summary: {
    id: 'mdc.wrappers.collection.summary',
    defaultMessage: '{count, number} {count, plural, one {item} other {items}} displayed',
  },
  empty: {
    id: 'mdc.wrappers.collection.summary.empty',
    defaultMessage: 'No items found',
  },
});

const defaultSummary = count => (
  <FormattedMessage
    values={{ count }}
    {...messages.summary}
  />
);

const defaultEmpty = <FormattedMessage {...messages.empty} />;

const CollectionSummary = ({
  collection,
  messages: {
    summary = defaultSummary,
    empty = defaultEmpty,
  },
}) => (
  isEmpty(collection)
    ? <EmptyTitle title={empty} />
    : summary(length(collection))
);

CollectionSummary.propTypes = {
  collection: array.isRequired, // eslint-disable-line react/forbid-prop-types
  messages: shape({
    summary: func,
    empty: node,
  }),
};

CollectionSummary.defaultProps = {
  messages: {},
};

export default CollectionSummary;
